function assertUnreachable(x: never): asserts x is never {
  if (process.env.NODE_ENV === "development") {
    throw new Error(`Unexpected code reached. x: ${x}`);
  }
}
export default assertUnreachable;
